import { Actions, Subjects } from 'permissions/ability.ts';
import { useAbility } from 'permissions/hooks/useAbility.ts';

export const useHasInLifePermissions = () => {
  const ability = useAbility();

  const inLifeActivation = ability.can(Actions.make, Subjects.inLifeActivation);
  const inLifeSuspension = ability.can(Actions.make, Subjects.inLifeSuspension);
  const inLifeUnsuspension = ability.can(Actions.make, Subjects.inLifeUnsuspension);
  const inLifeCancelLocation = ability.can(Actions.make, Subjects.inLifeCancelLocation);
  const inLifeTermination = ability.can(Actions.make, Subjects.inLifeTermination);

  return (
    inLifeActivation ||
    inLifeSuspension ||
    inLifeUnsuspension ||
    inLifeCancelLocation ||
    inLifeTermination
  );
};
